// 3rd party
import { Injectable } from '@angular/core';
import { Http, Response, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class SupplementService {

  constructor(
    private http: Http
  ) { }

  download(identifiers: string[]): Observable<any> {
    return this.http
      .get('calibrations/supplements/download/' + JSON.stringify(identifiers), { responseType: ResponseContentType.Blob })
      .map(res => new Blob([res.blob()], { type: res.headers.get('content-type').toString() }))
      .catch(err => Observable.throw(new Error(err)));
  }

  get(identifier?: string, search?: string, orderBy?: string, sortOrder?: string, pageSize?: number, currentPage?: number, filters?: string, fields?: string): Observable<Response> {
    currentPage = currentPage || 1;

    return this.http
      .get('calibrations/supplements/' + (identifier ? identifier : '') + '?fields=[' + (fields ? fields : '') + ']' + (search ? '&search=' + search : '') + (orderBy ? '&orderBy=["' + orderBy + (sortOrder ? ' ' + sortOrder : '') + '"]' : '') + (pageSize ? '&pageSize=' + pageSize + '&currentPage=' + currentPage : '') + (filters ? '&filters=[' + filters + ']' : ''))
      .map((res: Response) => res)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  view(identifier: string): Observable<any> {
    return this.http
      .get('calibrations/supplements/view/' + identifier, { responseType: ResponseContentType.Blob })
      .map(res => new Blob([res.blob()], { type: res.headers.get('content-type').toString() }))
      .catch(err => Observable.throw(new Error(err)));
  }
}



// WEBPACK FOOTER //
// ./src/app/calibrations/shared/supplement.service.ts